var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 8.5C16.8977 12.6108 13.442 16 9.10804 16C4.77411 16 1.31842 12.6108 1.31842 8.5C1.31842 4.38918 4.77411 1 9.10804 1C13.442 1 16.8977 4.38918 16.8977 8.5Z",
    stroke: "#082254",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3047 21.7189C20.7017 22.1028 21.3347 22.0922 21.7187 21.6952C22.1026 21.2982 22.092 20.6651 21.695 20.2811L20.3047 21.7189ZM15.4905 14.2811C15.0935 13.8972 14.4605 13.9078 14.0765 14.3048C13.6926 14.7018 13.7032 15.3349 14.1002 15.7189L15.4905 14.2811ZM21.695 20.2811L15.4905 14.2811L14.1002 15.7189L20.3047 21.7189L21.695 20.2811Z",
    fill: "#082254",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cd8a7e4c6f13c138d00202c785ae19dc.svg";
export { ForwardRef as ReactComponent };